import { IFormState } from './models'

export const initialState: IFormState = {}

export enum ValidationType {
  ONBLUR = 'onblur',
  ONCHANGE = 'onchange',
  MANUALLY = 'manually',
}
